<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="employee_advance"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="employeeAdvanceForm"
          :redirect-detail="true"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Pengajuan Kasbon"
          addButton="Buat Pengajuan"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center">Tambah Pengajuan Kasbon</h3>
          </div>

          <b-form id="employeeAdvanceForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="title" label="Title">
                    <b-form-input
                      id="title"
                      type="text"
                      v-model="$v.employeeAdvanceForm.title.$model"
                      :state="!$v.employeeAdvanceForm.title.$invalid"
                      required
                      placeholder="Title"
                    ></b-form-input>
                    <b-form-invalid-feedback>Title harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group
                    label-for="advance_type"
                    label="Tipe Kasbon"
                  >
                    <model-select
                      id="advance_type"
                      :options="listEmployeeAdvanceType"
                      v-model="$v.employeeAdvanceForm.advance_type.$model"
                      :isError="$v.employeeAdvanceForm.advance_type.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>

                    <div
                      v-if="employeeAdvanceForm.advance_type === null"
                      class="invalid-feedback-custom"
                    >
                      Tipe Kasbon harus di isi.
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Description">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.employeeAdvanceForm.description.$model"
                      :state="!$v.employeeAdvanceForm.description.$invalid"
                      required
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                      >Deskripsi harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button
                type="button"
                size="sm"
                variant="danger"
                @click="cancelAdd"
              >
                <i class="fa fa-undo"></i> Back </b-button
              >&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.employeeAdvanceForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import _interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_division",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      employee_advance: [],
      loading: true,
      loadingSubmitModal: false,
      listEmployeeAdvanceStatus: [],
      listEmployeeAdvanceType: [],
      fields: [
        { key: "title", label: "Title", class: "width-250" },
        {
          key: "advance_type_name",
          label: "Tipe Kasbon",
          class: "width-250",
          sortable: true,
        },
        { key: "request_by_name", label: "Request By", class: "width-250" },
        { key: "request_date", label: "Tanggal Pengajuan", class: "width-250" },
        { key: "request_by_name", label: "Pengajuan Oleh", class: "width-250" },
        {
          key: "status_name",
          label: "Status",
          class: "width-250",
          sortable: true,
        },
        { key: "description", label: "Description", class: "width-300" },
        { key: "action", class: "width-50 text-center" },
      ],
      employeeAdvanceForm: _interfaces.employee_advance,
      isEdit: false,
    };
  },
  validations: {
    employeeAdvanceForm: {
      title: { required },
      advance_type: { required },
      description: { required },
      request_date: {},
      request_by: {},
      status: {},
      approved_by: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.getEmployeeAdvance();
      this.getDropdown();
    },
    getEmployeeAdvance: function () {
      this.axios
        .get("web/employee_advance/all/")
        .then((response) => {
          this.employee_advance = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("web/dropdown/employee-advance/")
        .then((response) => {
          this.listEmployeeAdvanceStatus = response.data.employee_advance_status;
          this.listEmployeeAdvanceType = response.data.employee_advance_type;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetForm: function () {
      for (var a in _interfaces.employee_advance) {
        _interfaces.employee_advance[a] = null;
      }
      this.employeeAdvanceForm = _interfaces.employee_advance;
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function (evt) {
      evt.preventDefault();

      if (confirm("Apakah anda ingin menambahkan pengajuan kasbon ini?")) {
        this.loadingSubmitModal = true;
        this.axios
          .post("web/employee_advance/add/", this.employeeAdvanceForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Pengajan Berhasil",
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: "Tambah Pengajan Gagal",
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmitModal = false;
            this.cancelAdd();
            this.init();
          });
      }
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

  